export default __webpack_public_path__ + "static/media/434.cc1c0376.png";